import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pia3-reset-password-component',
  templateUrl: './pia3-reset-password.component.html',
  styleUrls: ['./pia3-reset-password.component.scss'],
})
export class Pia3ResetPasswordComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
